/**
 * Fetch Top Contractors API
 *
 * API function for fetching top-rated contractors
 */

import { buildApiUrl, handleApiResponse } from '@/src/shared/api';
import { MOCK_CONTRACTORS } from '../model/mock';
import { mapContractorsToCardProps } from '../lib/mappers';
import type { ContractorCardProps } from '../ui/ContractorCard';
import type { ContractorApiResponse } from '../lib/mappers';

export interface FetchTopContractorsParams {
  limit?: number;
  useMock?: boolean;
}

/**
 * Fetch top-rated contractors
 */
export async function fetchTopContractors(
  params: FetchTopContractorsParams = {},
): Promise<ContractorCardProps[]> {
  const { limit = 4, useMock = process.env.NEXT_PUBLIC_IS_DEVELOPMENT === 'true' } = params;

  // Use mock data for development
  if (useMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        // Return limited contractors sorted by rating
        const sorted = [...MOCK_CONTRACTORS]
          .sort((a, b) => (b.rating || 0) - (a.rating || 0))
          .slice(0, limit);
        resolve(sorted);
      }, 800);
    });
  }

  // Real API call
  const url = buildApiUrl(
    `/contractors/top?limit=${limit}`,
  );

  const response = await fetch(url);
  const data = await handleApiResponse<ContractorApiResponse[]>(response);

  return mapContractorsToCardProps(data || []);
}
